/**
 * @Author:      jiang.weiwei
 * @DateTime:    2017-12-06 20:13:08
 * @Description: 已投稿库Js
 */
'use strict';
angular.module("pgcSubmissionLibraryModule", ['submissionLibraryServiceModule']).
controller('pgcSubmissionLibraryCtrl', ["$scope", "$filter", "httpService", "$q", "$timeout","submissionLibraryService","modalDialog", function($scope, $filter, httpService, $q, $timeout,submissionLibraryService,modalDialog) {
    initStatus();
    initData();
    /**
     * [initStatus description] 初始化参数
     */
    function initStatus() {
        $scope.status = {
            inputData: '',
            channelsOptions: [],
            articleTypeMap: {           //不同稿件的编辑页路由集合
            	0:"imagetext",
            	1:"atlas",
            	2:"video",
                3: "activity"
            },
            detailPageMap:{				//不同稿件的详情页路由集合
            	0:'imagetextdetail',
            	1:'atlasdetail',
            	2:'videodetail',
            	3:'pgcmanuscriptdetails'
            }
        };
        $scope.data = {
            listData: [],
            keywords: "", //检索的关键词
            selectedArray: [], //选中的数据
        };
        $scope.page = {
            CURRPAGE: 1,
            PAGESIZE: 12,
            PAGECOUNT: 1,
            ITEMCOUNT: 0
        };

        $scope.articleType = {
            0: '图文稿',
            1: '图集稿',
            2: '视频稿',
            3: '活动稿'
        };
        $scope.articleStatus = {
            0:'未提交',
            1:'待审核',
            2:'二次审核',
            3:'已签发',
            4:'已退稿'
        }

        initDropDownList();
        addChildRefresh();
    }

    function initData() {
        initChannelsList().then(function(data) {
            requestData();
        });
    }
    /**
     * [addChildRefresh description] 监听子页面保存，并刷新本身
     */
    function addChildRefresh() {
        window.addEventListener("storage", function(e) {
            if (e.key === "ls.refresh") {
                requestData();
            }
        }, false);
    }
    /**
     * [initDropDownList description] 初始化下拉菜单
     * @return {[type]} [description]
     */
    function initDropDownList() {
        $scope.status.typeOptions = [{
            name: "稿件状态",
            value: ''
        }, {
            name: "待审核",
            value: 0
        }, {
            name: "已签发",
            value: 1,
        }];
        $scope.status.selectedTypeOption = angular.copy($scope.status.typeOptions[0]);

    }

    function initChannelsList() {
        var deferred = $q.defer();
        httpService.http("/mcnww/web/channel/querySignChnlList.do", "", "get").then(function(data) {
            var item = data.data;
            var allchannel = {
                name: "发布渠道",
                value: ''
            };
            $scope.status.channelsOptions.push(allchannel);
            for (var i = 0; i < item.length; i++) {
                var creatJSON = {};
                creatJSON.name = item[i].channelName;
                creatJSON.value = item[i].id;
                $scope.status.channelsOptions.push(creatJSON);
            }
            $scope.status.selectedChannel = angular.copy($scope.status.channelsOptions[0]);
            deferred.resolve(data);
        });
        return deferred.promise;
    }
    /**
     * [requestData description] 产品列表查询
     * @return {[type]} [description]
     */
    $scope.requestData = function() {
        requestData();
    };
    /**
     * [requestData description] 初始化列表数据
     */
    function requestData() {
        var params = {
            articleStatus: $scope.status.selectedTypeOption.value,
            pubChannelId: $scope.status.selectedChannel.value,
            startTime: $scope.status.startDate,
            endTime: $scope.status.endDate,
            searchWord: $scope.data.keywords,
            currPage: $scope.page.CURRPAGE,
            pageSize: $scope.page.PAGESIZE,
        };
        $scope.loadingPromise = httpService.http("/mcnww/web/pgcArticle/pubList.do", params, "post").then(function(data) {
            //判断稿件状态  statusList的长度
            var statusList =  data.data.ldata;
            for(var i=0;i<statusList.length;i++){
                if(statusList[i].statusList.length==1){
                    statusList[i].singleStatus = statusList[i].statusList[0].articleStatus;
                }else if(statusList[i].statusList.length>1){
                    statusList[i].multipleStatus = 2;
                }
            }
            $scope.data.listData = data.data.ldata;

            $scope.page = {
                CURRPAGE: data.data.startPage,
                PAGESIZE: data.data.pageSize,
                ITEMCOUNT: data.data.totalResults,
                PAGECOUNT: data.data.totalPages
            };

        });
    }
    /**
     * [queryByDropdown description] 筛选条件触发后请求数据
     * @param  {[type]} key   [description] 请求对象参数key
     * @param  {[type]} value [description] 请求对象值
     * @return {[type]}       [description] null
     */
    $scope.queryByDropdown = function() {
        requestData();
    };
    /**
     * [fullTextSearch description;全文检索]
     * @param  {[type]} ev [description:按下回车也能提交]
     */
    $scope.fullTextSearch = function(ev) {
        if ((angular.isDefined(ev) && ev.keyCode == 13) || angular.isUndefined(ev)) {
            requestData();
        }
    };
    /**
     * [pageChanged description]分页请求
     * @return {[type]} [description]
     */
    $scope.pageChanged = function() {
        requestData();
    };
    /**
     * [dateFormat description] 时间格式化
     * @return {[type]} [description]
     */
    $scope.dateFormat = function(item) {
        item.newTime = $filter("date")(item.operTime, "yyyy-MM-dd HH:mm:ss").toString();
    };
    /**
     * [selectDoc description] 单选
     * @param  {[type]} item [description] 当前数据
     * @return {[type]}      [description]
     */
    $scope.selectDoc = function(item) {
        var index = $scope.data.selectedArray.indexOf(item);
        index > -1 ? $scope.data.selectedArray.splice(index, 1) : $scope.data.selectedArray.push(item);
    };
    /**
     * [selectPanel description] 全选当前面板的稿件
     * @param  {[type]} items [description] 当前面板
     * @return {[type]}       [description]
     */
    $scope.selectPanel = function(items) {
        if ($scope.data.listData.length > 0 && $scope.data.selectedArray.length == $scope.data.listData.length) {
            $scope.data.selectedArray = [];
        } else {
            $scope.data.selectedArray = [].concat($scope.data.listData);
        }
    };
    /**
     * [selectPanel description] 全选当前面板的稿件
     * @param  {[type]} items [description] 当前面板
     * @return {[type]}       [description]
     */
    $scope.selectPanel = function(items) {
        if ($scope.data.listData.length > 0 && $scope.data.selectedArray.length == $scope.data.listData.length) {
            $scope.data.selectedArray = [];
        } else {
            $scope.data.selectedArray = [].concat($scope.data.listData);
        }
    };
    /**
     * [viewDetails description] 查看详情
     * @return {[type]} [description]
     */
    $scope.viewDetails = function(element) {
        submissionLibraryService.lookMore(element).then(function(data) {
            // $scope.loadingPromise = httpService.http("/mcnww/admin/role/addEdit.do", data, "post").then(function(data) {
            //     requestData();
            // });
        });
    }
    /**
     * [deleteList description] 删除已投稿
     * @return {[type]} [description]
     */
    $scope.deleteList = function(item) {
        modalDialog.confirmModal("删除", "确认删除选中稿件吗？", function() {
            var params = {
                'articleIds':item.id
            };
            // multipleId($scope.data.selectedArray, params);
            httpService.http("/mcnww/web/pgcArticle/delPubArticles.do", params, "get").then(function(data) {
                requestData();
            });
        });
    };
}]);
